export enum SkidEndDetail {
  None = 'none',
  Mitered45 = 'mitered-45',
}
